import { create } from 'zustand';

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: number;
}

interface ChatStore {
  messages: ChatMessage[];
  isOpen: boolean;
  isLoading: boolean;
  /** Text to pre-fill in the AskMe input the next time the widget opens.
   *  Lets any page hand the user a kick-off prompt (e.g. "Write me a bio
   *  for my travel platform") without typing. Cleared by the widget on
   *  consumption. */
  pendingPrompt: string | null;
  addMessage: (msg: ChatMessage) => void;
  clearMessages: () => void;
  setIsOpen: (open: boolean) => void;
  toggleOpen: () => void;
  setIsLoading: (loading: boolean) => void;
  setPendingPrompt: (prompt: string | null) => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  isOpen: false,
  isLoading: false,
  pendingPrompt: null,
  addMessage: (msg) => set((s) => ({ messages: [...s.messages, msg] })),
  clearMessages: () => set({ messages: [] }),
  setIsOpen: (open) => set({ isOpen: open }),
  toggleOpen: () => set((s) => ({ isOpen: !s.isOpen })),
  setIsLoading: (loading) => set({ isLoading: loading }),
  setPendingPrompt: (pendingPrompt) => set({ pendingPrompt }),
}));
